import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 导入翻译资源
import jaTranslations from './locales/ja.json';
import zhTranslations from './locales/zh.json';

// 翻译资源
const resources = {
  ja: {
    translation: jaTranslations
  },
  zh: {
    translation: zhTranslations
  }
};

// 初始化i18n
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('preferred_language') || 'ja', // 从localStorage获取首选语言或默认日语
    fallbackLng: 'ja',
    debug: false, // 生产环境关闭调试
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'preferred_language',
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false, // React已经处理了XSS
    },

    // 命名空间配置
    defaultNS: 'translation',
    ns: ['translation'],

    // 键分隔符
    keySeparator: '.',
    nsSeparator: ':',

    // 支持嵌套
    supportedLngs: ['ja', 'zh'],
    nonExplicitSupportedLngs: true,

    // 后备配置
    fallbackNS: false,
    
    // 其他配置
    returnNull: false,
    returnEmptyString: false,
    returnObjects: false,
    joinArrays: false,

    // React配置
    react: {
      useSuspense: false,
      bindI18n: 'languageChanged',
      bindI18nStore: 'added removed',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
    },
  })
  .then(() => {
      // console.log('i18n initialized successfully');
  // console.log('Current language:', i18n.language);
  })
  .catch((error) => {
    console.error('i18n initialization failed:', error);
  });

export default i18n; 